import { render, staticRenderFns } from "./AssignmentStudyset.vue?vue&type=template&id=48fa52f2&scoped=true&"
import script from "./AssignmentStudyset.vue?vue&type=script&lang=js&"
export * from "./AssignmentStudyset.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentStudyset.vue?vue&type=style&index=0&id=48fa52f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa52f2",
  null
  
)

export default component.exports